import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from 'styled-components';
import { ResponsiveImage, popularIconWidth } from '../Image';
const StyledFlagIconImage = styled(ResponsiveImage) `
  height: ${o => o.theme.spacing(10)};
  width: ${o => o.theme.spacing(10)};
  border-radius: 50%;
  margin: ${o => o.theme.spacing(1)} auto;
  background-color: ${o => o.theme.color.deprecated.stoneDark};
`;
export const FlagIconImage = forwardRef(({ src, alt, className }, ref) => {
    return (_jsx(StyledFlagIconImage, { className: className, ref: ref, src: src, alt: alt, aspectRatios: {
            sm: 1,
            md: 1,
        }, loading: 'lazy', fetchPriority: 'low', widths: {
            sm: popularIconWidth,
            md: popularIconWidth,
            unit: 'px',
        } }));
});
//# sourceMappingURL=index.js.map